import Api from '../api/Api';
import resolve from '../util/Configuracao';
class RelatorioBeneficiariosApi extends Api {
  async consultarBeneficiariosGeral (filter) {
    console.log(filter);
    try {
      const urlBeneficiariosConsultaGeral = resolve('urlBeneficiariosConsultaGeral');
      const response = await this.fetch(urlBeneficiariosConsultaGeral, 'post', filter);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async gerarArquivo () {
    try {
      const urlGerarArquivoCaixaSaude = resolve('urlGerarArquivoCaixaSaude');
      const response = await this.fetch(urlGerarArquivoCaixaSaude);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async gerarArquivoDep () {
    try {
      const urlGerarArquivoCaixaSaudeDep = resolve('urlGerarArquivoCaixaSaudeDep');
      const response = await this.fetch(urlGerarArquivoCaixaSaudeDep);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async gerarArquivoCaixaTitulares (beneficiarios, tipoArquivo) {
    try {
      const urlGerarArquivoCaixaSaudeLista = resolve('urlGerarArquivoCaixaSaudeLista') + tipoArquivo;
      const result = await this.fetch(urlGerarArquivoCaixaSaudeLista, 'post', beneficiarios);
      return result.data;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async gerarArquivoCaixaDependentes (beneficiarios, tipoArquivo) {
    try {
      const urlGerarArquivoCaixaSaudeDepLista = resolve('urlGerarArquivoCaixaSaudeDepLista') + tipoArquivo;
      const result = await this.fetch(urlGerarArquivoCaixaSaudeDepLista, 'post', beneficiarios);
      return result.data;
    } catch (error) {
      console.error(error);
      return error;
    }
  }


  async consultarBeneficiariosJson (filter) {
    let beneficiarios = [];
    let result = await this.consultarBeneficiariosGeral(filter);
    for (var i = 0; i < result.length; i++) {
      let beneficiariosAux = result[i].nome.split(';');
      if (beneficiariosAux[0] !== 'MATRICULA') {
        let matricula = beneficiariosAux[0];
        let nome = beneficiariosAux[1];
        let cpf = beneficiariosAux[2];
        let titularidade = beneficiariosAux[3];
        let dataNasc = beneficiariosAux[4];
        let idade = beneficiariosAux[5];
        let estadoCivil = beneficiariosAux[6];
        let sexo = beneficiariosAux[7];
        let parentesco = beneficiariosAux[8];
        let dataInicio = beneficiariosAux[9];
        let dataFim = beneficiariosAux[10];
        let carteiraCaixa = beneficiariosAux[11];

        beneficiarios.push({matricula: matricula,
        nome: nome,
        cpf: cpf,
        titularidade: titularidade,
        dataNasc: dataNasc,
        idade: idade,
        estadoCivil: estadoCivil,
        sexo: sexo,
        parentesco: parentesco,
        dataInicio: dataInicio,
        dataFim: dataFim,
        carteiraCaixa: carteiraCaixa});
      }
    }
    return beneficiarios;
  }
}
export default RelatorioBeneficiariosApi;
